const COLUMNS = ["Staying Ahead", "One-off Workshops", "Self-Service Courses"] as const;

type Row = {
  label: string;
  values: readonly [boolean, boolean, boolean];
};

const ROWS: readonly Row[] = [
  {
    label: "Tied to your team's actual workflows",
    values: [true, false, false],
  },
  {
    label: "Live, expert-led sessions",
    values: [true, true, false],
  },
  {
    label: "On-demand access for new joiners",
    values: [true, false, true],
  },
  {
    label: "Daily reinforcement built into the working week",
    values: [true, false, false],
  },
  {
    label: "Organisation-specific content and resources",
    values: [true, false, false],
  },
];

const HEADER_BG = "#1D1D1B99";
const ROW_BG = "#10100F";

function Cell({ value }: { value: boolean }) {
  return (
    <img
      src={value ? "/business/b2bright.svg" : "/business/b2bcancel.svg"}
      alt={value ? "Yes" : "No"}
      className="mx-auto h-3 w-3 md:h-4 md:w-4"
      loading="lazy"
      decoding="async"
    />
  );
}

export default function BusinessComparison() {
  return (
    <section
      id="business-comparison"
      className="w-full bg-black font-fira text-white py-8 md:py-20"
    >
      <div className="mx-auto w-[90%] md:w-[80%]">
        {/* Heading */}
        <p className="font-fira text-sm font-normal uppercase tracking-[0.18em] text-[#FFFFFF]">
          How this compares
        </p>
        <div className="mt-3 flex flex-col gap-6 md:mt-4 md:flex-row md:items-start md:justify-between md:gap-10">
          <h2 className="font-fira-condensed text-[30px] font-medium leading-tight tracking-tight text-white md:max-w-2xl md:text-[42px] md:font-semibold">
            Why teams choose
            <br />
            Staying Ahead?
          </h2>
          <p className="font-fira text-sm font-normal leading-relaxed text-[#FFFFFF85] md:max-w-sm md:text-right md:text-base">
            The goal isn&apos;t awareness. It&apos;s adoption - teams that apply
            AI in their daily work, and keep doing it.
          </p>
        </div>

        {/* Table */}
        <div className="mt-8 overflow-hidden rounded-2xl border border-white/10 md:mt-12">
          <table className="w-full border-collapse">
            <thead>
              <tr style={{ backgroundColor: HEADER_BG }}>
                <th
                  scope="col"
                  className="w-[40%] px-4 py-4 text-left md:w-[40%] md:px-6 md:py-6"
                >
                  <span className="sr-only">Capability</span>
                </th>
                {COLUMNS.map((col) => (
                  <th
                    key={col}
                    scope="col"
                    className="px-2 py-4 text-center align-middle text-[12px] font-medium leading-tight text-white md:px-4 md:py-6 md:text-[15px]"
                  >
                    {col.split(" ").map((word, i, arr) => (
                      <span key={i}>
                        {word}
                        {i < arr.length - 1 ? <br /> : null}
                      </span>
                    ))}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {ROWS.map((row, idx) => (
                <tr
                  key={row.label}
                  style={{ backgroundColor: ROW_BG }}
                  className={
                    idx > 0 ? "border-t border-white/10" : "border-t border-white/10"
                  }
                >
                  <th
                    scope="row"
                    className="px-4 py-5 text-left text-[12px] font-normal leading-snug text-white/70 md:px-6 md:py-6 md:text-[15px]"
                  >
                    {row.label}
                  </th>
                  {row.values.map((value, i) => (
                    <td
                      key={i}
                      className="px-2 py-5 text-center align-middle md:px-4 md:py-6"
                    >
                      <Cell value={value} />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
